enum SCREENSIZES {
  MAX_WIDTH = 1400,
  MIN_HEIGHT = 609,
}

export { SCREENSIZES };
